/**
 * External Dependencies
 */
import 'jquery';
import Parallax from 'parallax-js';
import AOS from 'aos';

var scene = document.getElementById('scene');

if($("#scene").length > 0) {
  var parallaxInstance = new Parallax(scene, {
    relativeInput: true
  });
}

$(document).ready(() => {

  resizePictures();

  $( window ).resize(function() {
    resizePictures();
  });
  
  function resizePictures(){
    let pictures = document.querySelectorAll(".img--carre");
    if (pictures.length != 0) {
      
      for(let i = 1; i <= pictures.length; i++){
          let picturesWidth = pictures[i - 1];
          let widthPictures = picturesWidth.clientWidth ;
            if ((i - 1) == pictures.length) {
                pictures[i].style.height = (widthPictures)+"px";
            }else {
                pictures[i - 1].style.height = (widthPictures)+"px";
            }
        }
    }
  }

  $('.actualites__filtres').on('click', 'a', function(e) {
    e.preventDefault();
    let href = $(this).attr('href');
    
    for(let i = 0; i < $('.actualites__filtres a').length; i++) {
      $('.actualites__filtres a')[i].classList.remove('actif');
    }
    $(this).addClass('actif');
    
    $.ajax(href)
        .done(function(data) {
          //get next article and push at the end
          let targetArticle = $(data).find('.actus__container').html();
          $('.actus__container').html('');
          $('.actus__container').append( targetArticle );
          
      })
      .fail(function(jqxhr) {
          alert(jqxhr.responseText);
      });
  });
  const cursorHover = document.querySelectorAll('.cursor');
  const cursorEl = document.querySelector('.cursor__pointer--move__el');
  
  $('#prev-posts-link').on('click', 'a', function(e) {
    e.preventDefault();
 
    let $this = $(this);
    let href = $this.attr('href');
    $.ajax(href)
        .done(function(data) {
          //get next article and push at the end
          let targetArticle = $(data).find('.actus__container').html();
          $('.actus__container').append( targetArticle );
          cursorHover = document.querySelectorAll('.cursor');
          animate();
          //update button
          let targetBtn = $(data).find('#prev-posts-link').html();
          if(targetBtn == null) {
              $('#prev-posts-link').remove();
          } else {
              $('#prev-posts-link').html(targetBtn);
          }
      })
      .fail(function(jqxhr) {
          alert(jqxhr.responseText);
      });
  });

  const cursor = document.querySelector('.cursor__pointer--move');

  let currentX = 0;
  let currentY = 0;
  let aimX = 0;
  let aimY = 0;
  let speed = 0.2;

  const animate = function () {
    currentX += (aimX - currentX) * speed;
    currentY += (aimY - currentY) * speed;

    cursor.style.left = currentX + "px";
    cursor.style.top = currentY + "px";

    requestAnimationFrame(animate);
    cursorHover.forEach(icon => {
      icon.addEventListener("mouseover", function () {
        cursorEl.style.opacity = "1";
        cursorEl.style.transform = "translate(-50%, -50%) scale(1)";
        document.documentElement.style.cursor = 'none !important';
      });
      icon.addEventListener("mouseout", function () {
        cursorEl.style.opacity = "0";
        cursorEl.style.transform = "translate(-50%, -50%) scale(0)";
        document.documentElement.style.cursor = 'auto';
      });
      
    })
  }

  animate();

  document.addEventListener("mousemove", function (event) {
    aimX = event.pageX;
    aimY = event.pageY;
  });

  

  $('.nav__btn').on('click', function(e) {
    $('body').toggleClass('nav--open');
  });
  
  var runAnimation = false;

  setTimeout(function(){ 
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 320, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
    });
    document.addEventListener('scroll', function (e) {
      if($('.section--number').length) {
        var top  = window.pageYOffset + window.innerHeight,
          isVisible = top > document.querySelector('.section--number').offsetTop + 500;
    
       if (isVisible && runAnimation != true) {
        runAnimation = true;
          let value = document.querySelectorAll(".value");
          for(let i = 0; i < value.length; i++) {
            animateValue(value[i], 0, value[i].innerHTML, 3000);
            console.log(value[i].innerHTML);
            console.log(i);
          }
       }
      }
      
    });
  }, 1500);

  var prevScrollpos = window.pageYOffset;
  var nav = document.querySelector('nav');

  window.onscroll = function() {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      nav.style.transform = "translateY(0)";
      nav.classList.add('nav--fixed');
    } else {
      nav.classList.remove('nav--fixed');
      nav.style.transform = "translateY(-300px)";
    }
    prevScrollpos = currentScrollPos;
    if(prevScrollpos < 600 ) {
      nav.classList.remove('nav--fixed');
      nav.style.transform = "translateY(0)";
    }
  }

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  $('.team-container').each(function () {
    const $container = $(this);
    const $card = $container.find('.team__el');
    const count = $card.length;

    $card.on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        if ($this.hasClass('active')) {
            $this.removeClass('active');

            $container
                .find('.team-description')
                .slideUp(400, function () {
                    $(this).remove();
                });
        } else {
            // get text
            const text = $this.data('text');
            const winW = $(window).width();
            const template = `<div class="team-description row">
            
            <div class="description__container | col-12 col-lg-8 m-auto">
            <svg version="1.1" class="cross" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="94.926px" height="94.926px" viewBox="0 0 94.926 94.926" style="enable-background:new 0 0 94.926 94.926;"
	 xml:space="preserve">
<g>
	<path d="M55.931,47.463L94.306,9.09c0.826-0.827,0.826-2.167,0-2.994L88.833,0.62C88.436,0.224,87.896,0,87.335,0
		c-0.562,0-1.101,0.224-1.498,0.62L47.463,38.994L9.089,0.62c-0.795-0.795-2.202-0.794-2.995,0L0.622,6.096
		c-0.827,0.827-0.827,2.167,0,2.994l38.374,38.373L0.622,85.836c-0.827,0.827-0.827,2.167,0,2.994l5.473,5.476
		c0.397,0.396,0.936,0.62,1.498,0.62s1.1-0.224,1.497-0.62l38.374-38.374l38.374,38.374c0.397,0.396,0.937,0.62,1.498,0.62
		s1.101-0.224,1.498-0.62l5.473-5.476c0.826-0.827,0.826-2.167,0-2.994L55.931,47.463z"/>
</g>

</svg>

              ${text}
            </div> </div>`;

            $card.removeClass('active');
            $this.addClass('active');

            $container
                .find('.team-description')
                .slideUp(400, function () {
                    $(this).remove();
                });

            // get the number of columns, to know where to insert template
            let columns = 1;
            if ($('#sm').is(':visible')) {
                columns = 2;
            }
            if ($('#md').is(':visible')) {
                columns = 3;
            }

            // append the template after the right column
            setTimeout(function() {
                const index = $this.index() + 1;
                let eq = 0;
                if (index % columns === 0) {
                    eq = index - 1;
                } else {
                    eq = index + (columns - (index % columns) - 1);
                    if (eq >= count) {
                        eq = count - 1;
                    }
                }

                $(template)
                    .insertAfter($card.eq(eq))
                    .slideDown(400, function() {
                        $('html, body').stop(true, true)
                            .animate({
                                scrollTop: $this.offset().top
                            }, 500);
                    });
                    $('.cross').on('click', function () {
                      $card.removeClass('active');
                      $container
                        .find('.team-description')
                        .slideUp(400, function () {
                            $(this).remove();
                        });
                    });
            },500);
          }
      });
  });

 
  

});
